exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-mobile-flow-diagram[data-v-f6b5b58a]{height:100%}", ""]);

// exports
